// extracted by mini-css-extract-plugin
export default {"textArea":"submit-for-expert-approval-modal_textArea__yIzqQ"};